const SELECT_SECTION = "SELECT_SECTION";
const SELECT_PRESET = "SELECT_PRESET";
const SCROLL_TO_INDEX = "SCROLL_TO_INDEX";
const RESET_DATA = "RESET_DATA";
const SHOW_HIDE_METRIC_GRAPH = "SHOW_HIDE_METRIC_GRAPH";
const SET_PATH = "SET_PATH";
const METRIC_ANIMATIONS_RUNNING = "METRIC_ANIMATIONS_RUNNING";
export { SELECT_SECTION, SELECT_PRESET, SCROLL_TO_INDEX, RESET_DATA, SHOW_HIDE_METRIC_GRAPH, SET_PATH, METRIC_ANIMATIONS_RUNNING };

